// Checklist enclosed by a repeat arrow, matching the native Redo app mark.
// The ring is centered at (48, 50), radius 39. Inset the checklist so its
// bottom-left corner clears the ring; leave the box corners open for ticks.
export const REDO_MARK_PATH = 'M85.09 62.05A39 39 0 1 1 87 50 M80 43l7 7 7-7 M35 28H28V40H40V36 M31 32l4 4 8-10 M50 29H73 M50 37H65 M35 46H28V58H40V54 M31 50l4 4 8-10 M50 47H73 M50 55H65 M35 64H28V76H40V72 M31 68l4 4 8-10 M50 65H73 M50 73H65';
export const REDO_MARK_STROKE = 3;

export function redoMarkSvg(color: string): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="${REDO_MARK_PATH}" fill="none" stroke="${color}" stroke-width="${REDO_MARK_STROKE}" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
}
